import VuexORM from '@vuex-orm/core'

const req = require.context('./', true, /^((?!index|\.unit\.|\.test\.).)*\.js$/)

const models = req.keys().map(req)

const database = new VuexORM.Database()

models.map((model) => {
  database.register(model.default)
})

export default VuexORM.install(database)
